import { CalendarDays } from "lucide-react";

const MONTHS = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
const FULL = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const norm = (arr) => (Array.isArray(arr) ? arr.map(Number).filter((m) => m >= 1 && m <= 12) : []);

export function PlantingCalendar({ crops }) {
  const rows = (crops || []).filter((c) => c.calendar && (norm(c.calendar.sow_months).length || norm(c.calendar.harvest_months).length));
  if (!rows.length) return null;

  return (
    <div className="bg-white rounded-2xl border border-stone-200 p-6" data-testid="planting-calendar">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <h3 className="font-display text-lg font-semibold text-emerald-900 flex items-center gap-2"><CalendarDays className="h-5 w-5 text-[#D97706]" /> Planting Calendar</h3>
        <div className="flex gap-4 text-xs text-stone-600">
          <span className="inline-flex items-center gap-1.5"><span className="h-3 w-3 rounded-sm bg-[#D97706]" /> Sow</span>
          <span className="inline-flex items-center gap-1.5"><span className="h-3 w-3 rounded-sm bg-[#2D6A4F]" /> Harvest</span>
          <span className="inline-flex items-center gap-1.5"><span className="h-3 w-3 rounded-sm bg-gradient-to-r from-[#D97706] to-[#2D6A4F]" /> Both</span>
        </div>
      </div>
      <div className="overflow-x-auto">
        <div className="min-w-[560px]">
          <div className="grid grid-cols-[140px_repeat(12,1fr)] gap-1 mb-1">
            <div />
            {MONTHS.map((m, i) => <div key={i} title={FULL[i]} className="text-center text-[11px] font-mono-tech text-stone-500">{m}</div>)}
          </div>
          {rows.map((c, i) => {
            const sow = new Set(norm(c.calendar.sow_months));
            const har = new Set(norm(c.calendar.harvest_months));
            return (
              <div key={i} data-testid={`calendar-row-${i}`} className="grid grid-cols-[140px_repeat(12,1fr)] gap-1 items-center mb-1.5">
                <div className="pr-2">
                  <div className="text-sm font-semibold text-emerald-950 truncate">{c.name}</div>
                  {c.calendar.note && <div className="text-[11px] text-stone-500 leading-tight line-clamp-2">{c.calendar.note}</div>}
                </div>
                {FULL.map((_, m) => {
                  const mo = m + 1, s = sow.has(mo), h = har.has(mo);
                  const cls = s && h ? "bg-gradient-to-r from-[#D97706] to-[#2D6A4F]" : s ? "bg-[#D97706]" : h ? "bg-[#2D6A4F]" : "bg-stone-100";
                  return <div key={m} title={`${FULL[m]}${s ? " · sow" : ""}${h ? " · harvest" : ""}`} className={`h-7 rounded-md ${cls}`} />;
                })}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
